// eslint-disable
import React from 'react';
import PropTypes from 'prop-types';
import Preloader from '../Preloader';
import MaterialCard from './MaterialCard';


export default class Materials extends React.Component {
    static propTypes = {
        // eslint-disable-next-line
        data: PropTypes.any,
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const items = [];
        let c = -1;
        this.props.data.forEach((o) => {
            // eslint-disable-next-line
            c = c + 1;
            // eslint-disable-next-line
            if (c === 0) o.tagClass = 'big_card';
            // eslint-disable-next-line
            if (c === 1) o.tagClass = 'normal_card';
            // eslint-disable-next-line
            if (c === 2) o.tagClass = 'small_card';
            // eslint-disable-next-line
            if (c === 3) o.tagClass = 'middle_card';
            // eslint-disable-next-line
            if (c === 4) o.tagClass = 'small_card';
            // eslint-disable-next-line
            if (c === 5) o.tagClass = 'normal_card';
            // eslint-disable-next-line
            if (c === 6) {
                // eslint-disable-next-line
                o.tagClass = 'big_card';
                c = -1;
            }

            items.push(o);
        });

        return (
            <div className="material--wrap">
                {items.length > 0
                    ? items.map((item, index) =>
                        (<MaterialCard
                            key={`material_${item._id.$id}_${(window.location.pathname.indexOf('materials') + 1 === 0) ? '_widget' : '_page'}`}
                            className={`${(index >= 0 && index < 2) ? 'first_row' : ''}`}
                            {...item} 
                        />))
                    : <Preloader />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Materials/Material.jsx